export const eAristoQuestionStyleType = {
    singleChoice: 0,
    completeTheSentence: 1,
    writeAnswer: 2,
    singleChoiceImage: 3,
};